module.exports = __webpack_public_path__ + "08_mole.b3903134.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer3/08_mole.png
// module id = cxQ6
// module chunks = 0